module.exports = __webpack_public_path__ + "static/media/voltmill-4.d84188b8.jpg";